/**
 * The external dependencies.
 */
import {combineReducers} from 'redux';
import {handleActions} from 'redux-actions';
/**
 * The internal dependencies.
 */
import {taskViewSet, workPlanner,} from './actions';

const view = handleActions({
    [taskViewSet]: (state, {payload}) => state !== payload ? payload : '',
}, '');

const inform = handleActions({
    [workPlanner]: (state) => 'planner',
}, '');

export default combineReducers({
    view,
    inform,
});


// WEBPACK FOOTER //
// ./src/store/task-view/reducer.js